<script setup lang="ts">

import {SocialWidgetData} from "@/SocialWidget/types/types";
import RootButton from "@/Pages/SocialWidget/Widget/Components/RootButton.vue";
import {onMounted, ref} from "vue";
import OpenPopup from "@/SocialWidget/Widget/WidgetWrap/OpenPopup.vue";
import WelcomeMessage from "@/Pages/SocialWidget/Widget/Components/WelcomeMessage.vue";
import {emitStatsEvent} from "@/utils";
import SimulatorWA from "@/Pages/SocialWidget/Widget/Components/SimulatorWA.vue";

const props = defineProps<{
    settings: SocialWidgetData,
    widgetId: string,
    endpoint: string,
}>();

const positionStyles = () => {
    if(props.settings !== null) {
        let res = {
            bottom: `${props.settings.view_settings.margin_y}px`,
            right: '',
            left: '',
        };
        if (props.settings.view_settings.position === 'left') {
            res['left'] = `${props.settings.view_settings.margin_x}px`;
        } else {
            res['right'] = `${props.settings.view_settings.margin_x}px`;
        }
        return res;
    }
}

const isOpen = ref(false);
const isWelcome = ref(false);
const isSimulator = ref(false);
const isShow = ref(false);
const domain = props.endpoint.replace('/sw/api/v1', '');

const trackView = () => {
    if(props.settings.view_settings.is_enable) {
        const lastShownKey = 'dg-sw-last-visit-'+ props.widgetId;
        const lastShown = localStorage.getItem(lastShownKey);
        if (lastShown && (Date.now() - Number(lastShown)) < (24 * 360 * 1000)) {
            return;
        }
        localStorage.setItem(lastShownKey, Date.now().toString());
        fetch(`${props.endpoint}/${props.widgetId}/track/view?type=sw`, {method: 'post'});
    }
}
setTimeout(trackView, 2000);
setTimeout(()=> {
    if(!isSimulator.value) {
        isWelcome.value = true;
    }
}, (props.settings.view_settings.welcome_delay + props.settings.view_settings.welcome_delay) * 1000)
setTimeout(() => {
    isShow.value = true;
}, props.settings.view_settings.widget_delay * 1000)

function getMessengerUrl(type: string) :string {
    return `${props.endpoint}/${props.widgetId}/redirect?` + [
        `messenger=${type}`,
        `current_url=${encodeURIComponent(window.location.href)}`,
        `referer=${document.referrer}`,
        `device=${getUserDevice()}`,
        `source=sw`,
        `text=`
    ].join('&');
}

function getUserDevice():string {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }

    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
    }

    return "desktop";
}


function openMessenger(type: string) {
    window.open(getMessengerUrl(type),'_blank');
}

function clickRootButton(): void {

    if (!props.settings.view_settings.popup_enabled && props.settings.subscription_limits?.copyright) {
        if (props.settings.messengers_settings.wa_enabled && !props.settings.messengers_settings.tg_enabled) {
            emitStatsEvent('dg_social_click_wa', props.settings.stats_counters);
            openMessenger('wa');
        }
        if (!props.settings.messengers_settings.wa_enabled && props.settings.messengers_settings.tg_enabled) {
            emitStatsEvent('dg_social_click_tg', props.settings.stats_counters);
            openMessenger('tg');
        }
        if (props.settings.messengers_settings.wa_enabled && props.settings.messengers_settings.tg_enabled) {
            isOpen.value = !isOpen.value; isSimulator.value = false;
            emitStatsEvent('dg_social_open', props.settings.stats_counters);
        }
    }

    else {
        isOpen.value = !isOpen.value; isSimulator.value = false;
        emitStatsEvent('dg_social_open', props.settings.stats_counters);
    }
}

// setTimeout(() => {
//     if(props.settings.messengers_settings.wa_enabled) {
//         if(!isOpen.value) {
//             isSimulator. value = true;
//             if(props.settings.view_settings.simulator_enabled) {
//               isWelcome.value = false;
//             }
//         }
//     }
// }, props.settings.view_settings.welcome_delay * 1000 + props.settings.view_settings.simulator_delay * 1000)

// onMounted(() => {
//     if (props.settings.view_settings.isShowLeave) {
//         document.addEventListener('mouseleave', showSimulator);
//     }
// });
// const showSimulator = () => {
//     if(props.settings.messengers_settings.wa_enabled) {
//         isSimulator.value = true;
//         isWelcome.value = false;
//         isOpen.value = false;
//     }
// }

declare global {
    interface Window {
        ym?: any;
    }
}

</script>

<template>
    <div class="fixed"
         v-if="props.settings.view_settings.is_enable && isShow"
         style="z-index: 999999"
        :style="positionStyles()">

        <OpenPopup
            @close="isOpen = false; isWelcome = false;"
            class="dg_widget-popup-animation"
            :settings="settings"
            :endpoint="endpoint"
            :widget-id="widgetId"
            v-show="isOpen"/>
<!--        <SimulatorWA-->
<!--            class="mb-2"-->
<!--            @close="isSimulator = false"-->
<!--            v-if="isSimulator && settings.view_settings.simulator_enabled"-->
<!--            :settings="settings"-->
<!--            :endpoint="endpoint"-->
<!--            :widget-id="widgetId"-->
<!--            :is-open="true"/>-->

        <WelcomeMessage
            class="cursor-pointer mb-2 dg_widget-welcome-animation"
            v-if="!isOpen && isWelcome && settings.view_settings.welcome_enabled && settings.subscription_limits?.premium"
            :settings="settings.view_settings"
            @close="isWelcome = false"
            @open-popup="isOpen = true"/>
        <div class="flex"
             :class="settings.view_settings.position === 'left' ? 'justify-start' : 'justify-end'">
            <RootButton
                v-if="!isOpen"
                @click="clickRootButton()"
                class="cursor-pointer dg_widget-animation" :domain="domain"
                :settings="{
                    view_settings: settings.view_settings,
                    messengers_settings: settings.messengers_settings,
                    premium: settings.subscription_limits?.premium
                }"/>
        </div>

    </div>
</template>

<style scoped>

</style>
